module.exports = __webpack_public_path__ + "img/Skirt-Front-B6-Da-Fb-Ga-Hc-Ia-outside.db04989e.png";